import React from 'react';

/**
 * Premium styled loading indicator with animations
 */
const LoadingIndicator = ({ text = 'Loading data...' }) => (
  <div className="flex flex-col items-center justify-center h-full py-12">
    <div className="relative">
      {/* Outer ring */}
      <div className="w-12 h-12 rounded-full border-2 border-emerald-200/30 border-t-emerald-500 animate-spin"></div>
      
      {/* Inner pulse effect */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-6 h-6 rounded-full bg-emerald-500/30 animate-ping"></div>
      </div>
      
      {/* Center dot */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-2 h-2 rounded-full bg-emerald-400"></div>
      </div>
    </div>
    
    <p className="mt-4 text-emerald-300 text-sm font-light">{text}</p>
    
    {/* Loading dots */}
    <div className="flex space-x-2 mt-2">
      <div className="w-1.5 h-1.5 bg-emerald-500/50 rounded-full animate-pulse"></div>
      <div className="w-1.5 h-1.5 bg-emerald-500/50 rounded-full animate-pulse" style={{ animationDelay: '300ms' }}></div>
      <div className="w-1.5 h-1.5 bg-emerald-500/50 rounded-full animate-pulse" style={{ animationDelay: '600ms' }}></div>
    </div>
  </div>
);

export default React.memo(LoadingIndicator);